import { attributes } from '../../imports'

// eslint-disable-next-line
export function getFallbackAds(isSteam, locale) {
    const origin = isSteam ? attributes.steamOrigin : attributes.defaultOrigin

    // Since we don't have this in japanese
    let useLocale = 'en'
    if (locale !== 'ja') useLocale = locale

    return [
        {
            id: '1337',
            src: attributes.fallbackSource.replace('{locale}', useLocale),
            link: attributes.fallbackLink.replace('{origin}', origin),
        },
    ]
}



// WEBPACK FOOTER //
// ./src/features/Ads/data/feed/api.js